import axios from 'axios';

export const http = axios.create({
  headers: {
    Accept: 'application/json',
  },
});

export const removeTokenFromRequestHeader = () => {
  delete http.defaults.headers.common.Authorization;
};
